import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, ExternalLink, AlertCircle } from "lucide-react";
import { ALLERGENS } from "@/data/catalog";

/**
 * Page admin Allergènes — lecture seule en Phase 0.
 * Les allergènes sont centralisés dans `/app/frontend/src/data/catalog.js`.
 * En Phase 1, cette page permettra d'ajouter / modifier / désactiver des
 * allergènes via l'API.
 */
export const AdminAllergens = () => (
  <div data-testid="admin-page-allergens" className="space-y-6">
    <header>
      <div className="text-[11px] uppercase tracking-[0.28em] text-[#FF9500] font-street inline-flex items-center gap-2">
        <ShieldAlert size={12} /> Sécurité alimentaire
      </div>
      <h1 className="font-street mt-2 text-3xl tracking-wide">Allergènes</h1>
      <p className="mt-2 text-sm text-white/55 leading-snug max-w-2xl">
        Liste affichée sur la page publique <code className="mx-1 text-white/80">/allergenes</code>.
        Les textes restent indicatifs : ne jamais écrire "sans traces" ou
        "garanti sans allergène".
      </p>
    </header>

    <div className="rounded-2xl border border-[#262626] bg-[#0F0F0F] p-5">
      <div className="text-[10px] uppercase tracking-[0.28em] text-white/45 font-street mb-3">
        {ALLERGENS.length} allergènes référencés
      </div>
      <ul className="grid gap-3 sm:grid-cols-2">
        {ALLERGENS.map((a) => (
          <li
            key={a.id}
            className="rounded-xl border border-[#262626] bg-[#0A0A0A] p-3"
            data-testid={`admin-allergen-${a.id}`}
          >
            <div className="font-street text-sm tracking-wide uppercase text-[#FF9500]">
              {a.name}
            </div>
            <div className="mt-1 text-[12px] text-white/65 leading-snug">
              {a.desc}
            </div>
          </li>
        ))}
      </ul>
    </div>

    <div className="rounded-2xl border border-[#262626] bg-[#0F0F0F] p-5 flex items-start gap-3">
      <AlertCircle size={16} className="text-[#FFC447] shrink-0 mt-0.5" />
      <div className="text-sm text-white/70 leading-snug">
        <strong className="text-white">En cours de développement.</strong>{" "}
        L'édition des allergènes depuis l'admin sera disponible en Phase 1.
        Pour modifier la liste actuelle, intervenez dans{" "}
        <code className="text-white/80">/app/frontend/src/data/catalog.js</code>.
      </div>
    </div>

    <Link
      to="/allergenes"
      className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.22em] font-street text-[#FF9500] hover:text-[#FFAA1F]"
    >
      Voir la page publique <ExternalLink size={12} />
    </Link>
  </div>
);

export default AdminAllergens;
